/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Architect_Detail9Inputs */

const en_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix plan with fixed price and a launch checklist.`)
};

const ar_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطة إصلاح بسعر ثابت وقائمة تحقق للإطلاق.`)
};

const bn_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিক্সড প্রাইস আর লঞ্চ চেকলিস্টসহ ফিক্স পরিকল্পনা।`)
};

const de_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix-Plan mit Festpreis und Start-Checkliste.`)
};

const es_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan de corrección con precio fijo y lista de lanzamiento.`)
};

const fr_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan de correction au forfait avec liste de lancement.`)
};

const pt_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano de correção com preço fixo e lista de lançamento.`)
};

const zh_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带固定价格和上线清单的修复计划。`)
};

const tr_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabit fiyatlı ve lansman listeli düzeltme planı.`)
};

const ru_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`План исправлений с фикс-прайсом и чек-листом запуска.`)
};

const pl_svc_ai_app_rescue_architect_detail9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan naprawy ze stałą ceną i checklistą startu.`)
};

/**
* | output |
* | --- |
* | "Fix plan with fixed price and a launch checklist." |
*
* @param {Svc_Ai_App_Rescue_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_architect_detail9 = /** @type {((inputs?: Svc_Ai_App_Rescue_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_architect_detail9(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_architect_detail9(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_architect_detail9(inputs)
	return en_svc_ai_app_rescue_architect_detail9(inputs)
});
export { svc_ai_app_rescue_architect_detail9 as "svc_ai-app-rescue_ARCHITECT_detail" }